import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import { CUSTOM_ELEMENTS_SCHEMA, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {
  CURRENCY_MASK_CONFIG,
  CurrencyMaskConfig,
  CurrencyMaskModule,
} from 'ng2-currency-mask';
import { NgxMaskModule } from 'ngx-mask';
import { WebcamModule } from 'ngx-webcam';
import { AngularMaterialModule } from './angular-material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ActionModule } from './shared/action/action.module';
import { DialogConfirmModule } from './shared/components/dialog-confirm/dialog-confirm.module';
import { KeyboardModule } from './shared/components/keyboard/keyboard.module';
import { LoadingComponent } from './shared/loading/loading.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { BaridConnectivityIndicatorComponent } from './shared/barid/barid-connectivity-indicator/barid-connectivity-indicator.component';
import { OfflineIndicatorComponent } from './shared/offline/offline-indicator/offline-indicator.component';
import { ChangePasswordModalComponent } from './shared/navbar/change-password-modal/change-password-modal.component';
import { SelectBranchModalComponent } from './shared/navbar/select-branch-modal/select-branch-modal.component';
import { NotificationModule } from './shared/navbar/notification/notification.module';
import { SideNavBarComponent } from './shared/navbar/side-nav-bar/side-nav-bar.component';
import { SubMenuComponent } from './shared/navbar/side-nav-bar/sub-menu/sub-menu.component';
import { SubMenu2Component } from './shared/navbar/side-nav-bar/sub-menu2/sub-menu2.component';
import { SubMenuUpBarComponent } from './shared/navbar/up-bar/sub-menu-up-bar/sub-menu-up-bar.component';
import { SubMenuUpBar2Component } from './shared/navbar/up-bar/sub-menu-up-bar2/sub-menu-up-bar2.component';
import { UpBarComponent } from './shared/navbar/up-bar/up-bar.component';
import { SharedModule } from './shared/shared.module';
import { httpInterceptorProvider } from './views/auth/http-interceptors';
import { MainLogInComponent } from './views/auth/main-log-in/main-log-in.component';
import { RecoverPasswordComponent } from './views/auth/recover-password/recover-password.component';
import { ResetPasswordComponent } from './views/auth/recover-password/reset-password/reset-password.component';
import { RegisterComponent } from './views/auth/register/register.component';
import { AuthService } from './views/auth/shared/auth.service';
import { HomeCardsModule } from './views/home-cards/home-cards.module';
import { HomeComponent } from './views/home/home.component';
import { NotificationsModalModule } from './views/notifications-modal/notification.module';
import { AccountsReceivableService } from './views/registration/accounts-receivable/crud-service';
import { ContractDialogModule } from './views/registration/contracts/components/contract-dialog/contracts-dialog.module';
import { CustomerAcessService } from './views/registration/customer-acess/crud-service';
import { CustomerAcessModule } from './views/registration/customer-acess/customer-acess.module';
import { DownloadsModule } from './views/registration/downloads/downloads.module';
import { FormEventService } from './views/registration/events-forms/form-event/form-event.service';
import { MarketingsModule } from './views/registration/marketings/marketings.module';
import { PasswordDialogModule } from './views/registration/password-dialog/password-dialog.module';
import { RegistrationModule } from './views/registration/registration.module';
import { LayoutCrudIndexModule } from './views/registration/shared/layout-crud-index/layout-crud-index.module';
import { ReasonDialogModule } from './views/registration/shared/reason-dialog/reason-dialog.module';
import { TrainingsModule } from './views/registration/trainings/trainings.module';
import { ValueReferencesModule } from './views/registration/value-reference/value-reference.module';
import { AiHelpModule } from './shared/ai-help/ai-help.module';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
};

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override firstPageLabel = 'Primeira página';
  override itemsPerPageLabel = 'Itens por página';
  override lastPageLabel = 'Última página';
  override nextPageLabel = 'Próximo';
  override previousPageLabel = 'Anterior';

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  };
}

registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavbarComponent,
    BaridConnectivityIndicatorComponent,
    OfflineIndicatorComponent,
    ChangePasswordModalComponent,
    SelectBranchModalComponent,
    UpBarComponent,
    SideNavBarComponent,
    SubMenuComponent,
    SubMenu2Component,
    SubMenuUpBarComponent,
    SubMenuUpBar2Component,
    MainLogInComponent,
    RecoverPasswordComponent,
    ResetPasswordComponent,
    RegisterComponent,
    LoadingComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AngularMaterialModule,
    FlexLayoutModule,
    NotificationModule,
    FormsModule,
    ReactiveFormsModule,
    RegistrationModule,
    DialogConfirmModule,
    WebcamModule,
    MatTableModule,
    CurrencyMaskModule,
    NgxMaskModule.forRoot(),
    KeyboardModule,
    ActionModule,
    DownloadsModule,
    MarketingsModule,
    TrainingsModule,
    MatDialogModule,
    MatProgressBarModule,
    PasswordDialogModule,
    NgxChartsModule,
    ValueReferencesModule,
    LayoutCrudIndexModule,
    ReasonDialogModule,
    CustomerAcessModule,
    ContractDialogModule,
    MatSnackBarModule,
    HomeCardsModule,
    NotificationsModalModule,
    SharedModule,
    AiHelpModule,
  ],
  providers: [
    httpInterceptorProvider,
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    FormEventService,
    AccountsReceivableService,
    CustomerAcessService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {
    // Implementar diretamente a lógica de redirecionamento sem depender de um serviço ainda não criado
    console.log('AppModule inicializado - configurando redirecionamento para parceiros');

    // Configurar lógica de navegação para parceiros
    if (this.authService.isUserLoggedIn() && this.authService.isPartner()) {
      console.log('Usuário do tipo parceiro - configurando redirecionamentos');
      // A lógica de navegação será implementada pelo AuthGuard
    }
  }
}
